import axiosClient from "../../../api/apiClient";

interface IOptions {
    id: number;
    type: string;
    status?: boolean;
}

export const APIArchiveUser = (options : IOptions) => {
    let url = "";
    let status = "";

    if (options.hasOwnProperty("status")) {
        status = "?status=" + options.status;
    }

    if(options.type === "students") {
        url = "/students";
    } else if(options.type === "teachers") {
        url = "/teachers";
    }

    return axiosClient.get(`${url}/archive/${options.id}${status}`);
};

export const APIRestoreUser = (options : IOptions) => {
    let url = "";

    if(options.type === "students") {
        url = "/students";
    } else if(options.type === "teachers") {
        url = "/teachers";
    }

    return axiosClient.get(`${url}/restore/${options.id}`);
};

export const APIUpdateUserClassrooms = (id: number, type: string, data: object) => {
    let url = "";

    if(type === "students") {
        url = "/students";
    } else if(type === "teachers") {
        url = "/teachers";
    }

    return axiosClient.put(`${url}/${id}/classrooms`, data);
};